import { AltiusRes, IEmail, IMoveEmailData, IResponseMeta, IUpdateEmail } from "store/types";

import { DealAction, ViewAction } from "..";
import { AsyncActions, AsyncActionsParams } from "../base";

export interface IEmailActions {
  moveEmailAction: (data: IMoveEmailData) => Promise<IEmail>;

  getEmailBoxAction: (dealId: number) => Promise<IResponseMeta>;
  updateEmailAction: (data: IUpdateEmail) => Promise<void>;
  deleteEmailAction: (item: IEmail) => Promise<void>;

  getEmailAction: (dealId: number, emailId: number) => Promise<void>;
  invalidateEmailMetaAction: () => void;

  getEmailsAction: (dealId: number) => Promise<void>;
}

interface EmailActionParams extends AsyncActionsParams {
  isSharedDeal: boolean;
}

export class EmailActions extends AsyncActions implements IEmailActions {
  protected readonly isSharedDeal: boolean;

  public constructor({ isSharedDeal, ...params }: EmailActionParams) {
    super(params);
    this.isSharedDeal = isSharedDeal;
  }

  public moveEmailAction: IEmailActions["moveEmailAction"] = async (data) => {
    const { email, sectionId } = data;
    const {
      data: { data: item }
    } = await this.api.post<AltiusRes<IEmail>>({
      url: `/api/v0.0.2/deals/${email.deal_id}/emails/${email.id}/move/sections/${sectionId}`
    });
    this.dispatch({
      type: DealAction.HandleEmailSuccess,
      payload: { item: email, event: "delete" }
    });
    this.dispatch({
      type: DealAction.HandleEmailSuccess,
      payload: { item, event: "add" }
    });
    return item;
  };

  public getEmailBoxAction = async (dealId: number): Promise<IResponseMeta> => {
    const {
      data: { data }
    } = await this.api.get<AltiusRes<IResponseMeta>>({
      url: this.isSharedDeal
        ? `/api/v0.0.3/shared-deals/${dealId}/incoming_emails`
        : `/api/v0.0.2/deals/${dealId}/incoming_emails`
    });
    return data;
  };

  public updateEmailAction = async (data: IUpdateEmail): Promise<void> => {
    const { dealId, emailId, is_private, email_subject } = data;

    const {
      data: { data: item }
    } = await this.api.patch<AltiusRes<IEmail>>({
      url: `/api/v0.0.2/deals/${dealId}/incoming_emails/${emailId}`,
      data: { is_private, email_subject }
    });
    this.dispatch({
      type: DealAction.HandleEmailSuccess,
      payload: { item, event: "update" }
    });
    this.dispatch({
      type: ViewAction.EmailBoxUpdate,
      payload: true
    });
  };

  public deleteEmailAction = async (item: IEmail): Promise<void> => {
    const { deal_id, id } = item;
    await this.api.delete({
      url: `/api/v0.0.2/deals/${deal_id}/incoming_emails/${id}`
    });
    this.dispatch({
      type: DealAction.HandleEmailSuccess,
      payload: { item, event: "delete" }
    });
    this.dispatch({
      type: ViewAction.EmailBoxUpdate,
      payload: true
    });
  };

  public getEmailAction = async (dealId: number, emailId: number): Promise<void> => {
    const {
      data: { data: payload }
    } = await this.api.get<AltiusRes<IEmail>>({
      url: `/api/v0.0.2/deals/${dealId}/incoming_emails/${emailId}`
    });
    this.dispatch({ type: DealAction.GetEmailMetaSuccess, payload });
  };

  public invalidateEmailMetaAction = (): void => {
    this.dispatch({ type: DealAction.InvalidateEmailMeta, payload: null });
  };

  // For a new changed structure
  public getEmailsAction = async (dealId: number): Promise<void> => {
    const {
      data: { data }
    } = await this.api.get<AltiusRes<Record<number, IEmail>>>({
      url: `/api/v0.0.3/deals/${dealId}/incoming-emails`
    });
    this.dispatch({ type: DealAction.GetEmailsSuccess, payload: data });
  };
}
